'use client';

import {retryPromise} from '@utils/retryPromise';
import {lazy, Suspense} from 'react';

import {ModalProps} from './types';

const Impl = lazy(
  retryPromise(
    async () => import(/* webpackChunkName: "searchModal" */ './SearchModal'),
    {fallback: {default: () => null}},
  ),
);

export const LazySearchModalWrapper = (props: ModalProps) => {
  if (!props.isOpen) {
    return null;
  }
  return (
    <Suspense>
      <Impl {...props} />
    </Suspense>
  );
};
